import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import kitImg from "../assets/photos/kit.jpg";
import { GIFT_EXAMPLES, waLink } from "../lib/site";

export default function GiftSection() {
    return (
        <section className="relative bg-obsidian py-20 sm:py-28 lg:py-32 overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_30%,rgba(197,160,89,0.12),transparent_55%)]" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
                <div className="lg:col-span-7">
                    <SectionHeader
                        light
                        eyebrow="Presentes personalizados"
                        title={
                            <>
                                Um presente que tem
                                <br />
                                <span className="italic text-gold">a sua história</span>
                            </>
                        }
                        sub="Mais do que um presente, uma lembrança feita especialmente para alguém especial. Escolha o produto, envie sua ideia e deixe a personalização por nossa conta."
                    />

                    <Reveal delay={0.2}>
                        <div className="flex flex-wrap gap-2.5 mt-9">
                            {GIFT_EXAMPLES.map((g) => (
                                <span
                                    key={g}
                                    data-testid={`gift-chip-${g.toLowerCase().replace(/\s/g, "-")}`}
                                    className="font-body text-xs text-cream/85 border border-gold/30 rounded-full px-4 py-2 hover:border-gold hover:text-gold transition-colors"
                                >
                                    {g}
                                </span>
                            ))}
                        </div>
                    </Reveal>

                    <Reveal delay={0.28}>
                        <button
                            data-testid="gifts-cta"
                            onClick={() =>
                                window.open(
                                    waLink(
                                        "Olá! Vim pelo site da Magnus e quero montar meu presente personalizado.",
                                    ),
                                    "_blank",
                                )
                            }
                            className="mt-10 bg-gold text-obsidian font-body text-xs sm:text-sm font-bold uppercase tracking-[0.16em] px-8 py-4 rounded-full hover:bg-gold-light transition-all duration-300 hover:-translate-y-0.5"
                        >
                            Quero montar meu presente
                        </button>
                    </Reveal>
                </div>

                <div className="lg:col-span-5 relative">
                    <Reveal delay={0.15}>
                        <PhotoFrame
                            dark
                            img={kitImg}
                            ratio="aspect-[4/5]"
                            testId="gifts-frame"
                        />
                    </Reveal>
                    <Reveal delay={0.3}>
                        <p className="font-display italic text-xl sm:text-2xl text-cream/70 leading-snug mt-8 max-w-xs">
                            "Eternizando momentos especiais através de produtos
                            personalizados."
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
